import { useTranslation } from 'react-i18next'

import { SIZE } from '../../../../constants/size'
import { useNotification } from '../../../../hooks'
import { FormModal } from '../../../Form'
import { useResizeModal } from '../../../Modal'
import {
  CREATE_CHECKLIST_FORM_INITIAL_VALUES,
  QA_NAME_CREATE_CHECKLIST_MODAL,
  QA_NAME_CREATE_CHECKLIST_SUBMIT,
} from '../RequestProfileTabInternalTasks.constants'

import { FormFields } from './FormFields'
import {
  getCreateChecklistPayload,
  getCreateChecklistValidationSchema,
} from './RequestProfileTabInternalTasksCreateModal.utils'

function RequestProfileTabInternalTasksCreateModal({ onClose, onCreate }) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  const { fullScreen, handleResizeModal } = useResizeModal()

  const validationSchema = getCreateChecklistValidationSchema()

  async function handleSubmit({ setSubmitting, value }) {
    return onCreate(value)
      .then(response => {
        onClose()
        handleAddSuccessNotification({
          text: t('RequestProfile.InternalTasksListCreatedTextKey', {
            name: response.data.name,
          }),
          title: t('RequestProfile.InternalTasksListCreatedTitleKey'),
        })
      })
      .catch(() => {
        handleAddErrorNotification('Error.CommonApiRequestFailKey')
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <FormModal
      Fields={FormFields}
      containerProps={{
        boxSize: SIZE.X_LARGE,
        isFullScreen: fullScreen,
        qaName: QA_NAME_CREATE_CHECKLIST_MODAL,
        onResize: handleResizeModal,
      }}
      formBodyProps={{
        contentProps: {
          isFullScreen: fullScreen,
          size: SIZE.X_LARGE,
        },
        submitButtonText: 'RequestProfile.InternalTasksCreateModalSubmitKey',
        submitQaName: QA_NAME_CREATE_CHECKLIST_SUBMIT,
        withNotifications: true,
      }}
      formTitle='RequestProfile.InternalTasksCreateModalTitleKey'
      getPayload={getCreateChecklistPayload}
      initialValues={CREATE_CHECKLIST_FORM_INITIAL_VALUES}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}

export default RequestProfileTabInternalTasksCreateModal
